import { render, staticRenderFns } from "./SectionFiveBox.vue?vue&type=template&id=080d7924&scoped=true&"
import script from "./SectionFiveBox.vue?vue&type=script&lang=js&"
export * from "./SectionFiveBox.vue?vue&type=script&lang=js&"
import style0 from "./SectionFiveBox.vue?vue&type=style&index=0&id=080d7924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080d7924",
  null
  
)

export default component.exports